import axios from 'axios';
import { getStore, setStore } from './storage';
import { router } from '../router/index';
import { Message } from 'view-design';
import Cookies from 'js-cookie';
import {bqjUrl} from '@/config/config';

// 统一请求路径前缀
let base = '/bqjvip';
// let API_ROOT = 'https://fzxhback.bqj.cn'; //正式环境
//let API_ROOT = 'https://previpback.bqj.cn' //预发布环境
//let API_ROOT = 'https://tsfzxhback.bqj.cn' //测试环境
let API_ROOT = bqjUrl

// 超时设定
axios.defaults.timeout = 15000;

axios.interceptors.request.use(config => {
    return config;
}, err => {
    toast('请求超时');
    return Promise.resolve(err);
});

// http response 拦截器
axios.interceptors.response.use(response => {
    const data = response.data;
    // 根据返回的code值来做不同的处理(和后端约定)

    //if(router.currentRoute.name != 'monitor'){
        switch (data.code) {
            case 210:
                Cookies.set('userInfo', '');
                setStore('accessToken', '');
                Cookies.remove('accessToken');
                Cookies.remove('accessToken', { domain: 'bqj.cn' });
                var midPagesa = "_empty" + "?time=" + new Date().getTime() / 500;
                router.push(midPagesa);
                router.push('/');
                break;


            //用户未实名认证
            case 213:
                toast(data.message,function(){
                    router.push('/authentication');
                });
                break;


            //VIP未开通
            case 214:
                let userInfoOldfo = Cookies.get("userInfo")?JSON.parse(Cookies.get("userInfo")):'';
                if(userInfoOldfo.accountType == 'enterprise'){
                    toast("请购买产品后使用",function(){
                        let routeData = this.$router.resolve({ path: '/goods' });
                        window.open(routeData.href, '_blank');
                    })
                }else{
                    toast("请购买产品后使用",function(){
                        let routeData = this.$router.resolve({ path: '/goods' });
                        window.open(routeData.href, '_blank');
                    })
                }
                break;
            // case 215:
            //     let userInfoOLDtw = Cookies.get("userInfo")?JSON.parse(Cookies.get("userInfo")):'';
            //     if(userInfoOLDtw.accountType == 'enterprise'){
            //         toast(data.message,function(){
            //             router.push('/vipEnterprise');
            //         })
            //     }else{
            //         toast(data.message,function(){
            //             router.push('/vipPersonal');
            //         })
            //     }
            //     break;
            case 401:
                // 未登录 清除已登录状态
                Cookies.set('userInfo', '');
                setStore('accessToken', '');
                Cookies.remove('accessToken');
                Cookies.remove('accessToken', { domain: 'bqj.cn' });
                var midPagesb = "_empty" + "?time=" + new Date().getTime() / 500;
                router.push(midPagesb);
                router.push('/');
                // router.push('');
                break;
            case 403:
                // 没有权限
                if (data.message !== null) {
                    toast(data.message);
                } else {
                    toast("未知错误");
                }
                break;
            case 500:
                // 错误
                if (data.message !== null) {
                    if(response.config.url == '/bqjvip/user/sendSmsCode'){

                    }else{
                        toast(data.message);
                    }
                } else {
                    toast("未知错误");
                }
                break;
            default:
                return data;
        }
    //}

    return data;
}, (err) => {
    // 返回状态码不为200时候的错误处理
    console.log(err,'+++++++++++++++++++++++')
    // toast('连接错误，请重试');
    return Promise.resolve(err);
});

export const getRequest = (url, params) => {
    let accessToken = getStore('accessToken');
    return axios({
        method: 'get',
        url: `${API_ROOT}${base}${url}`,
        params: params,
        headers: {
            'accessToken': accessToken
        }
    });
};

export const getNoBaseRequest = (url, params) => {
    let accessToken = getStore('accessToken');
    return axios({
        method: 'get',
        url: `${API_ROOT}${url}`,
        params: params,
        headers: {
            'accessToken': accessToken
        }
    });
};

export const postRequest = (url, params) => {
    let accessToken = getStore("accessToken");
    return axios({
        method: 'post',
        url: `${API_ROOT}${base}${url}`,
        data: params,
        transformRequest: [function (data) {
            let ret = '';
            for (let it in data) {
                ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&';
            }
            ret = ret.substring(0, ret.length - 1);
            return ret;
        }],
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'accessToken': accessToken
        }
    });
};

export const putRequest = (url, params) => {
    let accessToken = getStore("accessToken");
    return axios({
        method: 'put',
        url: `${API_ROOT}${base}${url}`,
        data: params,
        transformRequest: [function (data) {
            let ret = '';
            for (let it in data) {
                ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&';
            }
            ret = ret.substring(0, ret.length - 1);
            return ret;
        }],
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'accessToken': accessToken
        }
    });
};

export const deleteRequest = (url, params) => {
    let accessToken = getStore('accessToken');
    return axios({
        method: 'delete',
        url: `${API_ROOT}${base}${url}`,
        params: params,
        headers: {
            'accessToken': accessToken
        }
    });
};

export const uploadFileRequest = (url, params) => {
    let accessToken = getStore('accessToken');
    return axios({
        method: 'post',
        url: `${API_ROOT}${base}${url}`,
        params: params,
        headers: {
            'accessToken': accessToken
        }
    });
};

/**
 * 无需token验证的请求 避免旧token过期导致请求失败
 * @param {*} url 
 * @param {*} params 
 */
export const getRequestWithNoToken = (url, params) => {
    return axios({
        method: 'get',
        url: `${API_ROOT}${base}${url}`,
        params: params
    });
};
